import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ShowDetailsModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.ShowDetailsModalv2 = (function (parent) {
    __extends(ShowDetailsModalv2, parent);

    function ShowDetailsModalv2(config) {
        var modal = ShowDetailsModalv2.__super__.constructor.call(this);

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#show-detail-ok', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });
    
        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    callbackok: null;
    callbackcancel: null;

    /**
    * HSN.ShowDetailsModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    ShowDetailsModalv2.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    ShowDetailsModalv2.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    ShowDetailsModalv2.prototype._show = function (data) {
        $.ajax('/watch/program-guide/showdetails' + "?" + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                data: data,
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml
                (
                    data,
                    0,
                    function () {
                        __scope.Center();
                        __scope.Content.animate({ opacity: 1 });
                        //handle any tooltips loaded
                        if (!Modernizr.touchevents) {
                            HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                        }
                        var elemetToFocus = __scope.Content.find('#current-show-title');
                        __scope.SetFocus(elemetToFocus);
                    },
                    function () {
                        //__scope.Center();
                    }
                );

                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return ShowDetailsModalv2;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Watch/ShowDetailsModalv2.js